import {MatrixClient, MatrixEvent} from 'matrix-js-sdk';

export const deleteMultipleMessages = async (
  matrixClient: MatrixClient,
  eventsToDelete: MatrixEvent[]
): Promise<MatrixEvent[]> => {
  try {
    const redactedEvents = [];

    if (eventsToDelete.length === 0) {
      throw new Error('No events to delete');
    }

    for (const event of eventsToDelete) {
      const effectiveEvent = event.getEffectiveEvent();
      const roomId = effectiveEvent.room_id;
      const eventId = effectiveEvent.event_id;

      if (roomId === undefined || eventId === undefined) {
        throw new Error('No room id or event id found for an event');
      }

      const deletionReason =
        event === eventsToDelete[0]
          ? `User deleted message`
          : 'One of multiple events redacted';

      await matrixClient.redactEvent(roomId, eventId, undefined, {
        reason: deletionReason
      });

      redactedEvents.push(event);
    }

    return redactedEvents;
  } catch (error) {
    console.error('Failed to redact the event:', error);
    throw error;
  }
};
